import React from "react";
import { FactCheckIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";
import type {
  ProjectFileAffordanceTarget,
  ProjectFileAffordances,
} from "../../../common/files/projectFileAffordances";
import { ContractFieldReviewHost } from "./ContractFieldReviewHost";
import {
  ContractFieldReviewSource,
  contractFieldReviewSourceFor,
} from "./contractFieldReviewSources";

/**
 * El icono «Revisar campos» al lado del nombre del PDF de un documento, junto
 * a Ver y Descargar: en la grilla de contratos de la edición y en los
 * documentos de la edición firmada. Lo usa el asiento del proyecto
 * (src/common/files/projectFileAffordances.tsx).
 *
 * El visor no se monta hasta el primer clic: mientras está cerrado, cada tabla
 * solo paga un estado vacío.
 */
export function useContractFieldReviewAffordances(): ProjectFileAffordances {
  const { langStore } = useRootStore();
  const [source, setSource] = React.useState<ContractFieldReviewSource | null>(
    null,
  );
  const title = langStore.contractFieldsReviewButton;

  // Pura (corre mientras se dibuja cada celda): el estado cambia en onClick.
  const affordancesFor = React.useCallback(
    (target: ProjectFileAffordanceTarget) => {
      const review = contractFieldReviewSourceFor(target);
      if (!review) return [];
      return [
        {
          key: "contract-field-review",
          title,
          icon: <FactCheckIcon fontSize="small" />,
          onClick: () => setSource(review),
        },
      ];
    },
    [title],
  );

  const close = React.useCallback(() => setSource(null), []);
  const element = (
    <ContractFieldReviewHost source={source} onClose={close} />
  );

  return { affordancesFor, element };
}
